import event from './event.js';
import firebase from 'firebase';
import ConfigService from './configurationService.js';

/**
 *
 * StoreFrontUtil
 *
 * @namespace StoreFrontUtil
 */
var StoreFrontUtil = function storeFrontUtilInit() {
    // Initialize firebase configuration
    var configTest = {
        apiKey: "AIzaSyDqxHBk_XzYormp9s3pXw9tOKXzJdODWIk",
        authDomain: "testpitch-f0a71.firebaseapp.com",
        databaseURL: "https://testpitch-f0a71.firebaseio.com",
        storageBucket: "testpitch-f0a71.appspot.com"
    };
    var configProd = {
        apiKey: "AIzaSyBrHFBKi6OTY_ygW7_Zt9Qf8vpBYjZQRc4",
        authDomain: "pitch-f99af.firebaseapp.com",
        databaseURL: "https://pitch-f99af.firebaseio.com",
        storageBucket: "pitch-f99af.appspot.com"
    };
    var firebaseInitialized = false;

    var publicMethods = {
        incrementSalesCounter: function(sponsorID, market) {
            var hostName = nuskin.util.Url.getHostname(window.location.href);
            var hostNameParts = hostName.split('.');
            var storeName = hostNameParts[0];
            var storeMarketPath = '/storefront/users/' + sponsorID + '/storefront/' + storeName + "/" + market;

            var fbApp = initFirebase();

            //Get store front sales count from firebase and increment it by 1
            fbApp.database().ref(storeMarketPath + '/salesCount/').once('value').then(function (snapshot) {
                var salesCount = snapshot.val();
                if (salesCount == null) {
                    salesCount = 0;
                }

                // Write the increment value back out to firebase.
                fbApp.database().ref(storeMarketPath).update({'salesCount': ++salesCount});
            });
        }
    };
    
    function initFirebase(){
        if (!firebaseInitialized) {
            firebaseInitialized = true;
            if (ConfigService.getMarketConfig().hasOwnProperty("siteUrl") && ConfigService.getMarketConfig().siteUrl.indexOf("www.nuskin.com") !== -1) {
                return firebase.initializeApp(configProd, 'storefrontFirebase');
            } else {
                return firebase.initializeApp(configTest, 'storefrontFirebase');
            }
        }
    }
    
    return publicMethods;
}();

export default StoreFrontUtil;



//////////////////
// WEBPACK FOOTER
// /Users/geoffsagers/dev/webcomponents/js/packages/common-account/node_modules/@nuskin/ns-util/src/storeFrontUtil.js
// module id = 307
// module chunks = 0